import type { Canvas, FileRecord, InboxItem } from "@cohesive/api-client";

export type { PendingFileEntry } from "@cohesive/ui-components";

export type UnifiedItem =
  | { kind: "canvas"; data: Canvas }
  | { kind: "folder"; data: FileRecord }
  | { kind: "file"; data: FileRecord }
  | { kind: "chat"; data: InboxItem };

export function getItemName(item: UnifiedItem["data"]): string {
  if ("name" in item && typeof item.name === "string") return item.name;
  if ("path" in item) {
    const path = (item as FileRecord).path;
    const cleaned = path.endsWith("/") ? path.slice(0, -1) : path;
    const segments = cleaned.split("/").filter(Boolean);
    return segments[segments.length - 1] || path;
  }
  return "";
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value < 10 ? value.toFixed(1) : Math.round(value)} ${units[i]}`;
}

export function getFileTypeLabel(contentType: string): string {
  if (!contentType) return "File";
  if (contentType.startsWith("image/"))
    return contentType.slice(6).toUpperCase();
  if (contentType.startsWith("video/"))
    return contentType.slice(6).toUpperCase();
  if (contentType.startsWith("audio/"))
    return contentType.slice(6).toUpperCase();
  if (contentType === "application/pdf") return "PDF";
  if (contentType.includes("spreadsheet") || contentType.includes("excel"))
    return "Spreadsheet";
  if (contentType.includes("csv")) return "CSV";
  if (contentType.includes("json")) return "JSON";
  if (contentType.includes("javascript")) return "JavaScript";
  if (contentType.includes("html")) return "HTML";
  if (contentType.includes("xml")) return "XML";
  if (contentType.startsWith("text/")) return "Text";
  return "File";
}
